import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("mj_token");
    if (!token) { setLoading(false); return; }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("mj_token"))
      .finally(() => setLoading(false));
  }, []);

  const sendOtp = (email) => api.post("/auth/send-otp", { email }).then((r) => r.data);

  const verifyOtp = async (email, otp, name) => {
    const { data } = await api.post("/auth/verify-otp", { email, otp, name });
    localStorage.setItem("mj_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("mj_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, sendOtp, verifyOtp, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
